import React, { useEffect, useState } from "react";
import { Table, Spin } from "antd";
import aiConsoleService from "services/aiconsoleservice";

const columns = [
  { title: "Agent", dataIndex: "agent_key", key: "agent_key", render: (v) => <span className="text-xs">{v}</span> },
  { title: "When", dataIndex: "when", key: "when", render: (v) => (v ? new Date(v).toLocaleString() : "") },
  { title: "Who", dataIndex: "who", key: "who" },
  { title: "Target", dataIndex: "target", key: "target" },
  { title: "Change", dataIndex: "what_changed", key: "what_changed", render: (v, r) => v || r.action },
  { title: "Reason", dataIndex: "reason", key: "reason", render: (v) => <span className="whitespace-pre-wrap">{v || ""}</span> },
];

const Audit = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let active = true;
    aiConsoleService.getAudit()
      .then((res) => active && setRows(res?.data ?? []))
      .catch(() => active && setRows([]));
    return () => { active = false; };
  }, []);

  if (rows === null) return <div className="p-8 flex justify-center"><Spin /></div>;

  return (
    <div data-testid="audit-panel" className="overflow-x-auto">
      <Table
        size="small"
        rowKey="id"
        dataSource={rows}
        columns={columns}
        pagination={{ pageSize: 20 }}
        locale={{ emptyText: "No changes recorded yet." }}
      />
    </div>
  );
};

export default Audit;
